const RevitData = [
  {
    core: [
      {
        id: "1",
        name: "Basic Floor Plan Drawing Task",
        karma: "200",
        description:
          "Create a basic floor plan drawing in your own perspective using any floor plan software of your choice. The floor plan should include at least two rooms, and must be dimensioned correctly. Save your drawing as a single PDF file and submit it to the designated channel using the hashtag #cl-rv-planhome.",
        link: "https://www.youtube.com/playlist?list=PLe_I-JWckL7HnPkUSHT3FhT4mEEz8OTYe",
        inner_description:
          "Make sure your PDF file includes your name in the filename, and that the dimensions are clear and easy to read. Your submission will be reviewed by a moderator before you receive your karma points.",
        example:
          "#cl-rv-planhome Hey! I’ve completed the basic floor plan drawing task. Here is the PDF file of my drawing.",
      },
      {
        id: "2",
        name: "House Design Creation",
        karma: "400",
        description:
          "Draw a plan and an elevation of your home in way you wish to live. Dimensions can be taken for granted as long as they adhere to standard values.submit the drawing as a pdf",
        link: "https://www.youtube.com/watch?v=0uylIF0Pt5U&list=PLe_I-JWckL7Gp1UeZws0_Irmh7qFJiRYe",
        inner_description:
          "After finishing the drawing task, upload your drawing as a single PDF file to the civil-engineering channel and include the hashtags #cl-rv-modelhome in your submission message to earn karma points.",
        example:
          "#cl-rv-modelhome Hey! I’ve completed designing a model of my house. Here’s is the PDF file of my drawing.",
      },
    ],
  },
]

export default RevitData
